import React, {ReactNode} from 'react';
import AbstractView from '@src/components/_views/AbstractView';
import Body from '@views/dashboard/admin/Body';

export default class AdminDashboard extends AbstractView {
    static pageTitle = 'Dashboards:Admin.page-title';

    protected renderContent(): ReactNode {
        return <Body/>;
    }
}
